import { Backdrop, Badge, Box, Button, CircularProgress, Stack, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Icons } from "../../../components/icons";
import AddLinkIcon from '@mui/icons-material/AddLink';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { endGameV2, getConsoleVersion2 } from "../../../APIConfig/version2Scenario";
import { submitFlag } from "../../../APIConfig/scenarioConfig";
import FlagsNew from "../../ViewScenariosCommon/ScenarioDetails/FlagsNew";
import Milestone from "../../ViewScenariosCommon/ScenarioDetails/Milestone";
import { GetIP } from "../../../components/GetIP";
import CustomModal from "../../../components/ui/CustomModal";
import FlagTTX from "./FlagTTX";
import Injects from "./Injects";
import { activeCorporateConsole, endActiveScenario, getConsoleVmStatus, softRebootActiveScenario, startActiveScenario } from "../../../APIConfig/NewCorporateApiConfig";
import FeedbackForm from "../../ParticipantProfile/ViewScenarioExercise/components/FeedbackForm";
// import rangestrom_logo from "../../../assests/rangestrom.png";
import rangestrom_logo from "../../../assests/rangestorm-clickable.svg";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { BiLogOut } from "react-icons/bi";


const NewCorporateConsole = () => {


    const token = localStorage.getItem("access_token");
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();

    const [reload, setReload] = useState(true);
    const [socket, setSocket] = useState(null);
    const [full, setFull] = useState(true);
    const [consoleUrl, setConsoleUrl] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [data, setData] = useState({});
    const [load, setLoad] = useState(false); // for main console data loading .. screen blocker
    const [flagLoader, setFlagLoader] = useState(false); //loader for flag submission and only loading appear while submit flag
    const [injects, setInjects] = useState([]);
    const injectsRef = useRef(injects);
    useEffect(() => {
        injectsRef.current = injects;
    }, [injects]);

    const [expandedIndex, setExpandedIndex] = useState(0);
    const [autoFlow, setAutoFlow] = useState(true);
    const [endModal, setEndModal] = useState(false)
    const [rebootModal, setRebootModal] = useState(false)
    const [rebooting, setRebooting] = useState(false)
    const [rebootNotice, setRebootNotice] = useState("")
    const [iframeKey, setIframeKey] = useState(0)
    const rebootPoll = useRef(null)

    const getConsoleData = async (SubmitFlagLoader = false, silent = false) => {
        try {
            const response = await activeCorporateConsole(id);
            if (response?.data) {
                setData(response.data);
                let newUrl = response.data?.participant?.vm?.console_url;
                if (newUrl) {
                    newUrl = newUrl.replace("vnc_lite.html", "vnc.html");
                    if (!newUrl.includes("autoconnect=")) {
                        const separator = newUrl.includes("?") ? "&" : "?";
                        newUrl = `${newUrl}${separator}autoconnect=1`;
                    }
                }
                // Update iframe URL if empty or if URL/token has changed from backend
                if (newUrl && newUrl !== consoleUrl) {
                    setConsoleUrl(newUrl);
                }

                if (response.data?.participant?.injects) {
                    setInjects(response.data.participant.injects);
                }
            }
        } catch (error) {
            if (!silent) {
                toast.error(error?.response?.data?.errors);
                navigate("/scenarios/active-scenarios");
            }
        } finally {
            if (SubmitFlagLoader) {
                setFlagLoader(false);
            } else if (!silent) {
                setLoad(false);
            }
        }
    };

    useEffect(() => {
        // initial api call
        setLoad(true);
        getConsoleData();
    }, [reload, id]);

    useEffect(() => {
        // flag submission loader trigger and api refresh
        if (flagLoader) {
            getConsoleData(true);
        }
    }, [flagLoader, id]);

    useEffect(() => {
        if (!id) return;

        let ws = null;
        let reconnectTimer = null;
        let isUnmounted = false;

        const connect = () => {
            if (isUnmounted) return;

            let wsBase = (process.env.REACT_APP_WEB_SOCKET_URL || "ws://localhost:8000").replace(/\/+$/, "");
            if (wsBase.startsWith("http://")) {
                wsBase = wsBase.replace("http://", "ws://");
            } else if (wsBase.startsWith("https://")) {
                wsBase = wsBase.replace("https://", "wss://");
            }

            let userId = data?.participant?.user?.id;
            if (!userId) {
                try {
                    const raw = localStorage.getItem("cyberrange_user");
                    if (raw) {
                        const parsed = JSON.parse(raw);
                        userId = parsed?.id || parsed?.user_id;
                    }
                } catch (e) {
                    // ignore
                }
            }

            const queryParams = new URLSearchParams();
            if (token) queryParams.set("token", token);
            if (userId) queryParams.set("user", String(userId));
            queryParams.set("active_id", String(id));

            const serverUrl = `${wsBase}/ws/injects/?${queryParams.toString()}`;

            try {
                ws = new WebSocket(serverUrl);
            } catch (err) {
                console.error("Failed to construct WebSocket:", err);
                return;
            }

            ws.onopen = () => {
                const authMessage = JSON.stringify({ token, user_id: userId, active_id: id });
                ws.send(authMessage);
            };

            ws.onmessage = (event) => {
                try {
                    const message = JSON.parse(event.data);

                    // 1. Participant-specific inject delivery
                    if (message.type === "inject_sent" && message.delivery) {
                        const newDelivery = message.delivery;
                        setInjects((prev) => {
                            const list = Array.isArray(prev) ? prev : [];
                            const exists = list.some(
                                (item) =>
                                    (newDelivery.id != null && item.id != null && String(item.id) === String(newDelivery.id)) ||
                                    (newDelivery.inject_id != null && item.inject_id != null && String(item.inject_id) === String(newDelivery.inject_id))
                            );
                            if (exists) return list;
                            return [...list, newDelivery];
                        });
                        const alreadyInList = (Array.isArray(injectsRef.current) ? injectsRef.current : []).some(
                            (item) =>
                                (newDelivery.id != null && item.id != null && String(item.id) === String(newDelivery.id)) ||
                                (newDelivery.inject_id != null && item.inject_id != null && String(item.inject_id) === String(newDelivery.inject_id))
                        );
                        if (!alreadyInList) {
                            showInjectToast(newDelivery);
                        }
                        getConsoleData(false, true);
                    }
                    // 2. Scenario-wide inject event (sync state quietly without treating broadcast payload as personal delivery)
                    else if (message.channel === "exercise_active" && message.event === "inject_sent") {
                        getConsoleData(false, true);
                    }
                    // 3. Scenario reload / notification
                    else if (message.notifications === "reload" || message.type === "reload") {
                        getConsoleData(false, true);
                    }
                } catch (e) {
                    console.error("Error handling WebSocket message:", e);
                }
            };

            ws.onerror = (error) => {
                console.error("WebSocket error:", error);
            };

            ws.onclose = () => {
                if (!isUnmounted) {
                    reconnectTimer = setTimeout(() => {
                        connect();
                    }, 3000);
                }
            };

            setSocket(ws);
        };

        connect();

        return () => {
            isUnmounted = true;
            if (reconnectTimer) clearTimeout(reconnectTimer);
            if (ws) {
                ws.close();
            }
        };
    }, [token, id, data?.participant?.user?.id]);

    const handleRefresh = () => {
        getConsoleData(false, true);
        setIframeKey((key) => key + 1);
    };

    const stopRebootPoll = () => {
        if (rebootPoll.current != null) {
            clearInterval(rebootPoll.current);
            rebootPoll.current = null;
        }
    };

    useEffect(() => {
        return () => stopRebootPoll();
    }, []);

    const watchUntilVmActive = () => {
        stopRebootPoll();
        const started = Date.now();
        let sawNonActive = false;
        const tick = async () => {
            const elapsed = Date.now() - started;
            try {
                const response = await getConsoleVmStatus(id);
                const status = String(response?.data?.vm_status || "").toUpperCase();
                if (status && status !== "ACTIVE") sawNonActive = true;
                const back = sawNonActive && status === "ACTIVE";
                const stayedUp = !sawNonActive && status === "ACTIVE" && elapsed > 15000;
                if (back || stayedUp) {
                    setRebootNotice("");
                    stopRebootPoll();
                    return;
                }
            } catch {
                // Nova may not answer while the guest is restarting.
            }
            if (elapsed > 120000) {
                setRebootNotice("The VM is still restarting. Use Refresh if the picture stays blank.");
                stopRebootPoll();
            }
        };
        tick();
        rebootPoll.current = setInterval(tick, 3000);
    };

    const handleSoftReboot = async () => {
        try {
            setRebooting(true);
            await softRebootActiveScenario(id);
            toast.success("Soft reboot started. The screen goes dark once while the VM restarts.");
            setRebootNotice("Soft reboot in progress. The screen goes dark once while the VM restarts.");
            setRebootModal(false);
            watchUntilVmActive();
        } catch (error) {
            toast.error(
                error?.response?.data?.detail ||
                error?.response?.data?.errors ||
                "Soft reboot failed. Please try again."
            );
            setRebootNotice("");
            stopRebootPoll();
        } finally {
            setRebooting(false);
        }
    };



    const showAllClickHandler = () => setOpenModal(true);
    const closeModalHandler = () => setOpenModal(false);





    ////////////////////// for ttx injects management ///////////////////////////////

    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const showInjectToast = (inject) => {
        toast.info(`New Inject: ${inject.title}`, {
            autoClose: 8000,
            onClick: () => {
                setSelectedInject(inject);
                setOpenInjectModal(true);
            }
        });
    };


    const [selectedInject, setSelectedInject] = useState(null);
    const [openInjectModal, setOpenInjectModal] = useState(false);

    const handleOpenInject = (inject) => {
        setSelectedInject(inject);
        setOpenInjectModal(true);
    };

    const renderInjects = () => (
        <Stack>
            {injects?.map((inject, index) => (
                <Box
                    key={inject?.id || inject?.inject_id || index}
                    onClick={() => handleOpenInject(inject)}
                    sx={{
                        p: 2,
                        mb: 2,
                        backgroundColor: "#1C1F28",
                        borderRadius: "8px",
                        cursor: "pointer",
                    }}
                >
                    <Typography variant="h6">
                        Inject {index + 1}
                    </Typography>
                    <Typography>{inject?.title}</Typography>
                </Box>
            ))}

        </Stack>
    );

    const renderTabs = (Details, FlagsContent, InjectsContent) => (
        <>
            <Tabs
                value={tabValue}
                onChange={handleChange}
                textColor="inherit"
                indicatorColor="primary"
                sx={{
                    borderBottom: "1px solid #2A2E39",
                    marginBottom: '16px'
                }}
            >
                <Tab label={'Details'} />
                <Tab label={'Flags'} />

                {InjectsContent && <Tab
                    // disabled={!injects?.length}
                    label={
                        <Badge
                            badgeContent={injects?.length || 0}
                            sx={{
                                "& .MuiBadge-badge": {
                                    right: -6,
                                    top: 6,
                                    color: "red",
                                },
                            }}
                        >
                            Injects
                        </Badge>
                    }
                />}
            </Tabs>

            {tabValue === 0 && Details}
            {tabValue === 1 && FlagsContent}
            {tabValue === 2 && renderInjects()}
        </>
    );

    // const simulateInject = () => {
    //     setInjects(prev => {
    //         const newInject = {
    //             inject_id: Date.now(), // always unique
    //             title: `Dummy Inject ${prev.length + 1}`,
    //             type: "subjective",
    //             description: "Testing websocket without backend"
    //         };
    //         showInjectToast(newInject);
    //         return [...prev, newInject];
    //     });

    // };


    // useEffect(() => {

    //     const interval = setInterval(() => {
    //         simulateInject();
    //     }, 5000); // 5 seconds

    //     return () => clearInterval(interval); // cleanup

    // }, []);


    const hasVM = data?.participant?.has_vm_access;
    const hasTTX = data?.participant?.has_ttx_access;
    // const showTTXOnly = !data?.participant?.has_vm_access && data?.participant?.has_ttx_access;


    // end api - active scenario
    const handleEnd = async (id) => {
        try {
            setLoad(true);
            await endActiveScenario(id);

            // refresh console data
            await getConsoleData();

        } catch (error) {
            toast.error(error?.response?.data?.errors);
        } finally {
            setEndModal(false);
        }
    };

    // start api - start active scenario
    const handleStart = async (id) => {
        setLoad(true)
        try {
            const response = await startActiveScenario(id);
            if (response?.data) {
                setData(response?.data);
                if (response.data?.participant?.injects) {
                    setInjects(response.data.participant.injects);
                }

            }
        } catch (error) {
            toast.error(error?.response?.data?.errors);
        } finally {
            setLoad(false)
        }

    }

    useEffect(() => {
        document.body.style.cursor = load || flagLoader ? "wait" : "default";
        return () => {
            document.body.style.cursor = "default";
        };
    }, [load, flagLoader]);


    //revamp code
    const allFlags = data?.participant?.exercise_phases
        ?.flatMap(phase => phase?.flags || []) || [];

    return (
        <Stack margin={3} width="100%">
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1, }}
                open={isActive}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {load ? (
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    height="90vh"
                    width="100%"
                >
                    <CircularProgress size={60} />
                    <Typography mt={2} color="#BCBEC1">
                        Hang tight, setting up your playground...
                    </Typography>
                </Stack>
            ) : (

                // first check scenaro is already end or not .. if end show end page other check scenario started or not
                data?.participant?.is_ended === false ?

                    // first check participant is started the scenario or not , if yes show excercise otherwise show dialoge for start
                    (data?.participant?.is_started === false
                        ? (
                            <>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        mb: 3,
                                        py: 8
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: "100%",
                                            maxWidth: 640,
                                            bgcolor: "rgba(0, 184, 217, 0.08)",
                                            borderRadius: "16px",
                                            p: 6,
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: "40px",
                                                mb: 3.5,
                                                display: "inline-block",
                                                animation: "floatRotate 2s ease-in-out infinite",
                                                "@keyframes floatRotate": {
                                                    "0%": {
                                                        transform: "translateY(0px) rotate(0deg)",
                                                    },
                                                    "25%": {
                                                        transform: "translateY(-4px) rotate(16deg)",
                                                    },
                                                    "50%": {
                                                        transform: "translateY(-6px) rotate(0deg)",
                                                    },
                                                    "75%": {
                                                        transform: "translateY(-4px) rotate(-16deg)",
                                                    },
                                                    "100%": {
                                                        transform: "translateY(0px) rotate(0deg)",
                                                    },
                                                },
                                            }}
                                        >
                                            ⏳
                                        </Typography>
                                        <Typography
                                            variant="h2"
                                            sx={{
                                                color: "#00B8D9",
                                                fontWeight: 700,
                                                mb: 2.5
                                            }}
                                        >
                                            Exercise Not Started
                                        </Typography>

                                        <Typography
                                            variant="h4"
                                            sx={{
                                                color: "#919EAB",

                                            }}
                                        >
                                            The exercise hasn't started yet. Click the button below to begin and unlock all content.
                                        </Typography>

                                        <Button
                                            variant="outlined"
                                            onClick={() => navigate('/scenarios/active-scenarios')}
                                            sx={{
                                                px: 3,
                                                borderRadius: "10px",
                                                textTransform: "none",
                                                fontWeight: 600,
                                                mt: 4,
                                                mr: 1.2
                                            }}
                                        >
                                            Back
                                        </Button>

                                        <Button
                                            variant="contained"
                                            onClick={() => handleStart(id)}
                                            sx={{
                                                px: 3,
                                                borderRadius: "10px",
                                                textTransform: "none",
                                                fontWeight: 600,
                                                mt: 4,
                                                ml: 1.2
                                            }}
                                        >
                                            Start Exercise
                                        </Button>
                                    </Box>
                                </Box>
                            </>


                        ) : (

                            <Stack direction="row" gap={1}>
                                {/* Sidebar */}

                                <Stack
                                    sx={{
                                        width: full ? "28%" : "0%",
                                        transition: full ? "width 0.3s ease-out" : "width 0.3s ease-in",
                                    }}
                                    height="95vh"
                                    style={{ overflowY: "scroll", scrollbarWidth: "none" }}
                                    className="example"
                                >
                                    <Stack>
                                        <Stack gap={0.5} sx={{
                                            position: "sticky", top: 0,
                                            height: '85vh',
                                            overflowY: "scroll",
                                        }}>
                                            {/* Header */}


                                            {/* logo */}
                                            <Stack direction="row" justifyContent="center" alignItems="center" my={2}>
                                                <img
                                                    src={rangestrom_logo}
                                                    alt="rangestrom_logo"
                                                    style={{ height: "auto", width: '284px' }}
                                                />
                                            </Stack>

                                            {/* back button, refresh and expand button */}
                                            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                                                <KeyboardBackspaceIcon sx={{ cursor: 'pointer', fontSize: '32px', }} onClick={() => navigate('/scenarios/active-scenarios')} />

                                                <Stack direction="row" gap={1} alignItems="center">



                                                    <Tooltip title="open console in new tab">
                                                        <OpenInNewIcon
                                                            onClick={() => window.open(consoleUrl, "_blank")}
                                                            style={{ fontSize: "24px", cursor: "pointer" }}
                                                        />

                                                    </Tooltip>

                                                    <Tooltip title="Refresh">
                                                        <Icons.refresh
                                                            onClick={handleRefresh}
                                                            style={{ fontSize: "24px", cursor: "pointer" }}
                                                        />
                                                    </Tooltip>
                                                    {hasVM && (
                                                        <Tooltip title="Soft reboot">
                                                            <RestartAltIcon
                                                                onClick={() => {
                                                                    if (!rebooting) setRebootModal(true);
                                                                }}
                                                                style={{
                                                                    fontSize: "24px",
                                                                    cursor: rebooting ? "default" : "pointer",
                                                                    opacity: rebooting ? 0.5 : 1,
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                    <Icons.doubleLeftArrow
                                                        style={{ fontSize: "36px", cursor: "pointer" }}
                                                        onClick={() => setFull(!full)}
                                                    />
                                                </Stack>
                                            </Stack>


                                            {/* Helper to render Scenario Info details sidebar */}
                                            {(() => {
                                                const renderScenarioInfo = () => (
                                                    <Stack p={2} gap={2} sx={{ backgroundColor: "#242B32", borderRadius: "12px", }}>
                                                        <Typography variant="h3" sx={{ fontSize: "20px" }}>
                                                            {data?.scenario_name || data?.scenario?.name}
                                                        </Typography>

                                                        {/* Severity & Score */}
                                                        <Stack direction="row" spacing={2}>
                                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                                <Typography sx={{ color: "#BCBEC1" }}>Score :</Typography>
                                                                <Typography sx={{ color: "#BCBEC1" }}>{`${data?.scenario?.points} Points`}</Typography>
                                                            </Stack>

                                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                                <Typography sx={{ color: "#BCBEC1" }}>Severity :</Typography>
                                                                <Typography sx={{ color: "#BCBEC1" }}>{data?.scenario?.severity}</Typography>
                                                            </Stack>
                                                        </Stack>

                                                        <Stack spacing={1} padding={'12px'}
                                                            sx={{ borderRadius: '6px', gap: '10px', backgroundColor: '#151A1F', }}>
                                                            <>
                                                                {/* Username */}
                                                                <Stack direction="row" alignItems="center" spacing={1} >
                                                                    <Icons.userPin style={{ color: "#BCBEC1" }} />
                                                                    <Typography sx={{ color: "#BCBEC1" }}>User Name:</Typography>
                                                                    <Typography sx={{ color: "#BCBEC1" }}>{data?.participant?.vm?.username}</Typography>
                                                                </Stack>

                                                                {/* Password */}
                                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                                    <Icons.key style={{ color: "#BCBEC1" }} />
                                                                    <Typography sx={{ color: "#BCBEC1" }}>Password:</Typography>
                                                                    <Typography sx={{ color: "#BCBEC1" }}>{data?.participant?.vm?.password}</Typography>
                                                                </Stack>
                                                            </>
                                                        </Stack>

                                                        <GetIP instances={data?.instances} />

                                                        {/* Walkthrough */}
                                                        {data?.participant?.walkthrough_files?.length > 0 && (
                                                            <Stack direction="column" alignItems="start">
                                                                <Typography sx={{ mb: 1 }}>Walkthrough</Typography>
                                                                <Stack
                                                                    direction="row"
                                                                    spacing={2}
                                                                    p={2}
                                                                    flexWrap="wrap"
                                                                >
                                                                    {data?.participant?.walkthrough_files.map((item, index) => (
                                                                        <Stack
                                                                            key={index}
                                                                            onClick={() => window.open(item?.file_url, "_blank")}
                                                                            sx={{
                                                                                cursor: "pointer",
                                                                                alignItems: "center",
                                                                                width: 90,
                                                                                "&:hover": {
                                                                                    transform: "scale(1.05)"
                                                                                }
                                                                            }}
                                                                        >
                                                                            <Icons.pdf
                                                                                style={{ color: "#BCBEC1", fontSize: 36 }}
                                                                            />
                                                                            <Typography variant="caption">
                                                                                Walkthrough {index + 1}
                                                                            </Typography>
                                                                        </Stack>
                                                                    ))}
                                                                </Stack>
                                                            </Stack>
                                                        )}

                                                        {openModal && (
                                                            <CustomModal open={openModal} onClose={closeModalHandler}>
                                                                <Box
                                                                    sx={{ color: "#BCBEC1", height: "560px", overflow: "auto" }}
                                                                    dangerouslySetInnerHTML={{ __html: data?.scenario?.objective }}
                                                                />
                                                            </CustomModal>
                                                        )}

                                                        {data?.scenario?.objective && (
                                                            <>
                                                                <Box sx={{ maxHeight: "300px", overflow: "auto" }}>
                                                                    <Box
                                                                        sx={{ color: "#BCBEC1" }}
                                                                        dangerouslySetInnerHTML={{ __html: data?.scenario?.objective }}
                                                                    />
                                                                </Box>

                                                                {/* Show All */}
                                                                <Stack direction="row" spacing={0.5}>
                                                                    <Icons.show style={{ color: "#92E7E1", cursor: "pointer" }} />
                                                                    <Typography
                                                                        onClick={showAllClickHandler}
                                                                        sx={{ color: "#92E7E1", cursor: "pointer" }}
                                                                    >
                                                                        Show All
                                                                    </Typography>
                                                                </Stack>
                                                            </>
                                                        )}
                                                    </Stack>
                                                );

                                                return (
                                                    <>
                                                        {/* only vm access */}
                                                        {hasVM && !hasTTX && (
                                                            renderTabs(
                                                                renderScenarioInfo(),
                                                                <FlagTTX
                                                                    active_scenario_id={data?.id}
                                                                    reload={reload}
                                                                    setReload={setReload}
                                                                    load={load}
                                                                    participant_id={data?.participant_id}
                                                                    scenario_type={data?.scenario?.type}
                                                                    setFlagLoader={setFlagLoader}
                                                                    flagLoader={flagLoader}
                                                                    flagData={allFlags}
                                                                    allData={data}
                                                                    param_id={id}
                                                                    is_started={data?.participant?.is_started}
                                                                    is_ended={data?.participant?.is_ended}
                                                                />,
                                                                false
                                                            )
                                                        )}

                                                        {/* vm + ttx access */}
                                                        {hasVM && hasTTX && (
                                                            renderTabs(
                                                                renderScenarioInfo(),
                                                                <FlagTTX
                                                                    active_scenario_id={data?.id}
                                                                    reload={reload}
                                                                    setReload={setReload}
                                                                    load={load}
                                                                    participant_id={data?.participant_id}
                                                                    scenario_type={data?.scenario?.type}
                                                                    setFlagLoader={setFlagLoader}
                                                                    flagLoader={flagLoader}
                                                                    flagData={allFlags}
                                                                    allData={data}
                                                                    param_id={id}
                                                                    is_started={data?.participant?.is_started}
                                                                    is_ended={data?.participant?.is_ended}
                                                                />,
                                                                true
                                                            )
                                                        )}
                                                    </>
                                                );
                                            })()}
                                        </Stack>

                                        {/* end Scenario Button */}
                                    </Stack>
                                    <Box
                                        sx={{
                                            position: "sticky",
                                            bottom: 0,
                                            background: "#111218",
                                            pt: 1.5,
                                            pb: 1,
                                            zIndex: 5
                                        }}
                                    >
                                        < Box
                                            variant="outlined"
                                            sx={{
                                                color: 'white',
                                                background: "linear-gradient(90deg, #08BED0, #03688C)",
                                                cursor: 'pointer',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: "center",
                                                padding: '12px',
                                                gap: '10px',
                                                borderRadius: '10px',
                                            }}
                                            onClick={() => setEndModal(true)}
                                        >

                                            <BiLogOut style={{
                                                fontSize: "20px",
                                                fill: "#FFFFFF",
                                            }} />
                                            End Scenario
                                        </Box>
                                    </Box>

                                </Stack>


                                {/* Toggle Full Sidebar */}
                                <Tooltip title="Details Page">
                                    <Icons.doubleRightArrow
                                        style={{
                                            fontSize: "36px",
                                            cursor: "pointer",
                                            width: full ? "0%" : "2.5%",
                                        }}
                                        onClick={() => setFull(!full)}
                                    />
                                </Tooltip>

                                {/* Main iframe content */}
                                {hasVM && <Stack
                                    style={{
                                        paddingTop: 4,
                                        paddingBottom: 4,
                                        display: "flex",
                                        width: !full ? "96%" : "78%",
                                        height: "95vh",
                                        position: "relative"
                                    }}
                                >

                                    {rebootNotice ? (
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: 12,
                                                left: 12,
                                                zIndex: 2,
                                                maxWidth: 360,
                                                px: 1.5,
                                                py: 1,
                                                borderRadius: "8px",
                                                backgroundColor: "rgba(21, 26, 31, 0.92)",
                                                border: "1px solid rgba(255,255,255,0.12)",
                                                color: "#EAEAEB",
                                                fontSize: "13px",
                                            }}
                                        >
                                            {rebootNotice}
                                        </Box>
                                    ) : null}
                                    <iframe
                                        key={iframeKey}
                                        // src={data?.participant?.vm?.console_url}
                                        src={consoleUrl}
                                        title="Tutorials"
                                        style={{ width: "100%", height: "100%" }}
                                        allow="fullscreen; clipboard-read; clipboard-write"
                                        allowFullScreen
                                    ></iframe>
                                </Stack>}

                                {injects?.length > 0 && (
                                    <Injects
                                        open={openInjectModal && injects.length > 0}
                                        setModal={setOpenInjectModal}
                                        injectData={selectedInject}
                                        onSubmit={() => getConsoleData(false, true)}
                                    />
                                )}



                                <CustomModal
                                    open={rebootModal}
                                    onClose={() => {
                                        if (!rebooting) setRebootModal(false);
                                    }}
                                    sx={{ width: "560px" }}
                                >
                                    <Box sx={{ p: 3 }}>
                                        <Typography
                                            variant="h6"
                                            sx={{ color: "#EAEAEB", mb: 1, fontWeight: 600, fontSize: "24px" }}
                                        >
                                            Soft reboot this VM?
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#BCBEC1",
                                                mb: 3,
                                                lineHeight: 1.7,
                                                fontSize: "15px"
                                            }}
                                        >
                                            OpenStack will send a graceful reboot to your virtual machine.
                                            The picture goes dark once while it restarts, then comes back in this console.
                                        </Typography>
                                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
                                            <Button
                                                variant="outlined"
                                                disabled={rebooting}
                                                onClick={() => setRebootModal(false)}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                variant="contained"
                                                disabled={rebooting}
                                                onClick={handleSoftReboot}
                                            >
                                                {rebooting ? "Rebooting…" : "Soft reboot"}
                                            </Button>
                                        </Box>
                                    </Box>
                                </CustomModal>

                                <CustomModal
                                    open={endModal}
                                    onClose={() => setEndModal(false)}
                                    sx={{ width: "820px" }}
                                >
                                    <Box sx={{ p: 3 }}>

                                        {/* Title */}
                                        <Typography
                                            variant="h6"
                                            sx={{ color: "#EAEAEB", mb: 1, fontWeight: 600, fontSize: "24px" }}

                                        >
                                            End Scenario
                                        </Typography>

                                        {/* Message */}
                                        <Typography
                                            sx={{
                                                color: "#BCBEC1",
                                                mb: 3,
                                                lineHeight: 1.7,
                                                fontSize: "15px"
                                            }}
                                        >
                                            Are you sure you want to end this scenario? <br /><br />
                                            Once you click <strong>End</strong>, the scenario will be permanently closed
                                            and you won’t be able to continue.
                                        </Typography>

                                        {/* Buttons */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                gap: 1
                                            }}
                                        >
                                            <Button
                                                variant="outlined"
                                                onClick={() => setEndModal(false)}
                                            >
                                                Cancel
                                            </Button>

                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={() => handleEnd(id)}
                                            >
                                                End Scenario
                                            </Button>
                                        </Box>

                                    </Box>
                                </CustomModal>

                            </Stack>


                        )
                    ) : (
                        // this will render when scenario already ended
                        <>
                            {/* SHOW FEEDBACK FORM */}
                            {data?.participant?.can_submit_feedback &&
                                !data?.participant?.is_feedback_submitted && (
                                    <FeedbackForm
                                        open={true}
                                        name={data?.participant?.user?.full_name}
                                        scenario={data?.scenario}
                                        participant_id={data?.participant?.id}
                                        team={data?.participant?.team?.name}
                                    />
                                )}

                            {/* SHOW COMPLETED MODAL */}
                            {data?.participant?.can_submit_feedback === false && (
                                <CustomModal
                                    open={true}
                                    hideCloseIcon={true}
                                >
                                    <Box
                                        sx={{
                                            width: "100%",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="h2"
                                            sx={{
                                                fontWeight: 700,
                                                mb: 2
                                            }}
                                        >
                                            Exercise Completed
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#637381",
                                                mb: 4.5,
                                                fontSize: 18,
                                            }}
                                        >
                                            This exercise has ended and submissions are now closed.
                                        </Typography>

                                        <Button
                                            variant="contained"
                                            onClick={() => navigate("/scenarios/active-scenarios")}
                                            sx={{
                                                px: 3,
                                                borderRadius: "10px",
                                                textTransform: "none",
                                                fontWeight: 600,
                                            }}
                                        >
                                            View Active Scenario
                                        </Button>
                                    </Box>
                                </CustomModal>
                            )}
                        </>
                    )

            )}
        </Stack>
    );
};

export default NewCorporateConsole;







/////////////// ////////////////







